import Vue from "vue";
import VueI18n from "vue-i18n";
import { env } from "@/env";
import en from "./locales/en.json";
import es from "./locales/es.json";

Vue.use(VueI18n);

function loadLocaleMessages() {
  return {
    en,
    es,
  };
}

export default new VueI18n({
  locale: env.i18nLocale,
  fallbackLocale: env.i18nFallbackLocale,
  messages: loadLocaleMessages(),
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});
